import { queryReceivableLedger } from '@/api/crm/finance'
import { amount, emptyDashboard } from './financeShared'

export default {
  data () {
    return {
      loading: false,
      reportYear: String(new Date().getFullYear()),
      queryParams: {
        contractYear: null,
        departmentName: null,
        productCategory: null,
        keyword: ''
      },
      dashboard: emptyDashboard()
    }
  },
  created () {
    this.queryData()
  },
  methods: {
    amount,
    buildParams () {
      return {
        reportYear: Number(this.reportYear),
        scene: this.$options.financeScene || 'full',
        contractYear: this.queryParams.contractYear || undefined,
        departmentName: this.queryParams.departmentName || undefined,
        productCategory: this.queryParams.productCategory || undefined,
        keyword: this.queryParams.keyword || undefined
      }
    },
    queryData () {
      if (!this.reportYear) return
      this.loading = true
      return queryReceivableLedger(this.buildParams()).then(response => {
        this.dashboard = Object.assign(emptyDashboard(), response.data || {})
      }).finally(() => {
        this.loading = false
      })
    },
    resetQuery () {
      this.reportYear = String(new Date().getFullYear())
      this.queryParams = {
        contractYear: null,
        departmentName: null,
        productCategory: null,
        keyword: ''
      }
      this.queryData()
    },
    openContract (row) {
      if (row && row.contractId) {
        window.open('/crm/contract/detail/' + row.contractId, '_blank')
      }
    }
  }
}
